import { createStore, useStore as useVuexStore, Store } from "vuex";

import { RootStateType, RootWithModule } from "./types";
import loginModule from "./login";
const store = createStore<RootStateType>({
  state() {
    return {
      departmentList: [],
      departmentCount: 0,
      roleList: [],
      roleCount: 0,
      menuList: [],
    };
  },
  getters: {},
  mutations: {
    changeDepartmentList(state: RootStateType, payload: any[]) {
      state.departmentList = payload;
    },
    changeDepartmentCount(state: RootStateType, payload: number) {
      state.departmentCount = payload;
    },
    changeRoleList(state: RootStateType, payload: any[]) {
      state.roleList = payload;
    },
    changeRoleCount(state: RootStateType, payload: number) {
      state.roleCount = payload;
    },
    changeMenuList(state: RootStateType, payload: any[]) {
      state.menuList = payload;
    }
  },
  actions: {
    
  },
  modules: {
    login: loginModule
  }
});

export function uploadCache() {
  store.dispatch("login/uploadAction");
}
export function useStore(): Store<RootWithModule> {
  return useVuexStore();
}

export default store;
